import { ShoppingBag, ListChecks, MessageCircle, PackageCheck } from "lucide-react";

const STEPS = [
  {
    icon: ShoppingBag,
    title: "Browse the collection",
    text: "Choose your favorite pieces, size, and color.",
  },
  {
    icon: ListChecks,
    title: "Add to Bag",
    text: "Review your selected items and estimated total.",
  },
  {
    icon: MessageCircle,
    title: "Confirm via WhatsApp",
    text: "Our team will confirm availability, payment, delivery, or pickup.",
  },
  {
    icon: PackageCheck,
    title: "Pick up or receive delivery",
    text: "Collect from Canggu/Ubud or arrange selected Bali delivery.",
  },
];

const HowToOrder = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="how-to-order"
      data-testid="how-to-order"
      className="py-20 md:py-28 bg-[hsl(var(--sand))]/40"
    >
      <div className="container-tjb">
        <div className="max-w-xl mb-12">
          <p className="eyebrow">Easy Shopping</p>
          <h2 className="h-section mt-3">How to Order</h2>
        </div>

        <ol className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <li
              key={s.title}
              className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-lg p-7 flex flex-col gap-4"
              data-testid={`how-step-${i + 1}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-3xl text-[hsl(var(--clay))]">
                  0{i + 1}
                </span>
                <s.icon className="w-5 h-5 text-[hsl(var(--ink))]/70" />
              </div>
              <h3 className="font-display text-xl">{s.title}</h3>
              <p className="text-sm text-[hsl(var(--ink))]/75 leading-relaxed">
                {s.text}
              </p>
            </li>
          ))}
        </ol>

        <div className="mt-10 flex justify-center">
          <button
            data-testid="how-start-shopping"
            onClick={() => scrollTo("collection")}
            className="btn-primary"
          >
            Start Shopping
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowToOrder;
